









































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import columns from "./customer-columns";
class PageCustomerRequest extends PageRequest {
  keyword: string;
  type: string;
}

@Component
export default class Customer extends mixins(ListMixin, AbpBase) {
  namespace = "customer";
  pagerequest: PageCustomerRequest = new PageCustomerRequest();
  spinShow: boolean = false;
  creationTime: Date[] = [];
  types = [];
  get store() {
    return this.$store.state.customer;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }

  get tenant() {
    return this.$store.state.session.tenant;
  }

  async getCustomerTypes() {
    this.types = [];
    await this.$store
      .dispatch({
        type: "customerType/getCustomerType",
        data: { hasAllItem: true },
      })
      .then((result) => {
        this.types = result;
        this.pagerequest.type = this.types.length === 0 ? "" : this.types[0].id;
      });
  }
  viewCustomer(code: string) {
    this.$root.$router.push({
      name: "customer/:code",
      params: { code: code },
    });
  }
  createCustomer() {
    this.$root.$router.push({ path: "create/customer" });
  }
  updateCustomer(code: string) {
    this.$root.$router.push({
      name: "update/customer/:code",
      params: { code: code },
    });
  }
  get list() {
    var re = this.$store.state.customer.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {}

  renderColumn() {
    return columns;
  }
  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 80,
    },
    ...this.renderColumn(),
    {
      title: Util.L("Action"),
      width: 100,
      fixed: "right",
      slot: "action",
      align: "center",
    },
  ];
  async created() {
    this.spinShow = true;
    try {
      await this.getCustomerTypes();
      var defaultDate = new Date();
      this.creationTime = [defaultDate, defaultDate];
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
